import { Injectable } from '@angular/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';

@Injectable()
export class NavigationService {
    private _previousUrls: string[];

    constructor(private router: Router) {
        this._previousUrls = [];
    }

    back(): void {
        this.router.navigateByUrl(this.getLastUrl());
    }

    init(): void {
        this.router.events.subscribe((event: RouterEvent) => {
            if (event instanceof NavigationEnd) {
                this.setPreviousUrl(event.urlAfterRedirects);
            }
        });
    }

    getLastUrl(): string {
        return this._previousUrls.length ? this._previousUrls[this._previousUrls.length - 2] : '/distributions';
    }

    setPreviousUrl(url: string): void {
        this._previousUrls.push(url);
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/distribution/services/navigation.service.ts